/**
 * Convertit un document profile (Plan #3) au format `users.preferences` legacy.
 *
 * Schéma profile  : { name, emoji, regime, allergies: object|array, aversions, blockPreferences, isDefault }
 * Schéma legacy   : { regime, allergies: object<key,bool>, aversions }
 *
 * Le format legacy attend `allergies` en objet (clé booléenne) pour matcher
 * `normalizeAllergies` côté preferencesOptions.js.
 */

export function profileToPreferences(profile) {
  if (!profile || typeof profile !== 'object') return null;

  // Normaliser allergies en objet {key: bool}
  let allergiesObj = {};
  if (Array.isArray(profile.allergies)) {
    profile.allergies.forEach((k) => {
      if (typeof k === 'string' && k.trim()) allergiesObj[k.trim()] = true;
    });
  } else if (profile.allergies && typeof profile.allergies === 'object') {
    allergiesObj = { ...profile.allergies };
  }

  return {
    regime: profile.regime || 'Omnivore',
    allergies: allergiesObj,
    aversions: typeof profile.aversions === 'string' ? profile.aversions : ''
  };
}
